import React from "react";
import ScanHand from "../../ScanHand";

const Screen06 = () => {
    return <ScanHand />;
};

export default Screen06;
